import {useEffect, useRef, useState} from 'react';
import Load from './Load';
import axios from 'axios';
import ReviewCard from './ReviewCard';

type ProfileReviewsListProps = {
    businessId: string;
}

export default function ProfileReviewsList({businessId} : ProfileReviewsListProps) {
  const postsRef = useRef();
  const [hasMore, setHasMore] = useState(true);
  const [posts, setPosts] = useState([]);

  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);

  const more = () => {
    if (loading || !hasMore) return;
    setLoading(true);
    axios.get(`${process.env.REACT_APP_API_URL}/business/${businessId}/reviews?skip=${current}&take=10`, {withCredentials: true})
        .then((res) => {
          const cPosts = posts;
          setPosts(cPosts.concat(res.data));
          setCurrent(current+10);
          setLoading(false);
          setHasMore(res.data.length === 10);
        });
  };

  useEffect(() => more());
  const onScroll = () => {
    if (postsRef.current) {
      const {scrollTop, scrollHeight, clientHeight} = postsRef.current;
      if (scrollTop + clientHeight === scrollHeight) {
        more();
      }
    }
  };


  return (
    <div onScroll={() => onScroll()} ref={postsRef}>
      {posts.flatMap((p, index) => (<ReviewCard review={p}/>))}
      {hasMore && <Load/>}
    </div>
  );
}
